import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useMemberWallet} from "../../../hooks/useMemberWallet";
import {deleteMemberAccountNo} from "../../../api/memberApi";
import {alertAfterFunction, defaultAlert, defaultConfirm} from "../../../utils/alert";

export default function AccountManagementPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const {memberWalletInfo, loading, error, refetch} = useMemberWallet();

    const confirmDeleteAccount = () => {
        defaultConfirm("계좌를 삭제하시겠습니까?", "삭제", "취소",
            (isConfirmed) => {
                if (isConfirmed) {
                    deleteAccountNo();
                } else {
                    return;
                }
            }
        );
    };

    const confirmChangeAccount = () => {
        defaultConfirm("다른 계좌로 변경하시겠습니까?", "계좌변경", "취소",
            (isConfirmed) => {
                if (isConfirmed) {
                    navigate('/wallet/accountVerification');
                } else {
                    return;
                }
            }
        );
    };


    const deleteAccountNo = async () => {
        const res = await deleteMemberAccountNo();
        if (res.data?.code == "00") {
            alertAfterFunction("삭제 되었습니다.", () => navigate('/'));
        } else {
            defaultAlert(res.data.message);
            return;
        }
    };


    return (
        <div>
            <div className="bottom-btn">
                <button
                    type="button"
                    className="btn cancel"
                    onClick={() => confirmDeleteAccount()}
                >
                    삭제
                </button>
                <button
                    type="button"
                    className="btn confirm"
                    onClick={() => confirmChangeAccount()}
                >
                    계좌 변경
                </button>
            </div>

            <main className="container">
                <form className="form-box">
                    <section className="bg-white">
                        <fieldset>
                            <legend>계좌 관리 폼</legend>
                        </fieldset>
                        <div className="inner-box">
                            <div className="form-item">
                                <label className="input-tit">예금주</label>
                                <div className="input-box">
                                    <input type="text" className="text-right" value={memberWalletInfo?.memberName ?? ""}
                                           readOnly/>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">은행</label>
                                <div className="input-box">
                                    <input type="text" className="text-right" value={memberWalletInfo?.bankName ?? ""}
                                           readOnly/>
                                </div>
                            </div>

                            <div className="form-item">
                                <label className="input-tit">계좌번호</label>
                                <div className="input-box">
                                    <input type="text" className="text-right" value={memberWalletInfo?.accountNo ?? ""}
                                           readOnly/>
                                </div>
                            </div>

                            <div className="form-item">
                                <ul className="guidF-list">
                                    <li>
                                        등록된 계좌는 잔액환불 신청에 따른 환불금액 지급 시 사용됩니다.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </section>
                </form>
            </main>
        </div>
    );
};

